import axios from '../../api/config';
import type { MessageOnlyResponse } from '../../types/messageOnlyResponse';

export interface SupportBody {
  name: string;
  email: string;
  phone: string;
  message: string;
}

export interface NewsletterBody {
  email: string;
}

export interface ErrorReportBody {
  error_data: string;
}

export const postSupportMessages = (
  body: SupportBody
): Promise<MessageOnlyResponse> => axios.post('/support-messages', body);

export const postNewsletters = (
  body: NewsletterBody
): Promise<MessageOnlyResponse> => axios.post('/newsletters', body);

export const postErrorReport = (
  body: ErrorReportBody
): Promise<MessageOnlyResponse> => axios.post('/error-reports', body);
